import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const patentOwnerApi = generateNomenApi(`/nomen/patent-owners`);

export const patentOwnerOptions = generateNomenOptions('patentOwner', patentOwnerApi);
